// Force scroll to top on hair quiz page
window.addEventListener('load', () => {
  if (window.location.pathname === '/pages/hair-quiz') {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }
})

document.addEventListener('DOMContentLoaded', () => {
  const rootSection = document.getElementById('hair-quiz')
  const stepsContainer = document.querySelector('[data-quiz-steps]')
  const resultsContainer = document.querySelector('[data-quiz-results]')

  if (!stepsContainer || !resultsContainer) return

  // Unique session id per quiz load
  const sessionId = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`

  const persistSessionIdToCart = id => {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        attributes: {
          hq_sessionId: id
        }
      })
    }).catch(err => {
      console.error('Failed to set quiz session on cart', err)
    })
  }

  const sendQuizProgress = payload => {
    const body = {
      sessionId,
      ...payload
    }

    fetch('https://br-backend.up.railway.app/api/quiz/progress', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).catch(err => {
      console.error('Failed to send quiz progress', err)
    })
  }

  // 1) QUIZ MODEL — age / texture / type / color / scent / masculine preference
  const quizSteps = [
    {
      id: 'age',
      question: 'How old are you?',
      required: true,
      type: 'single',
      options: [
        { value: 'under_20', label: 'Younger than 20' },
        { value: '20s', label: `20's` },
        { value: '30s', label: `30's` },
        { value: '40s', label: `40's` },
        { value: '50s', label: `50's` },
        { value: '60Plus', label: `60's +` }
      ]
    },
    {
      id: 'texture',
      question: "What's your natural, untreated, air-dried hair texture like?",
      required: true,
      type: 'single',
      options: [
        { value: 'straight', label: 'Straight 1A-1C' },
        { value: 'wavy', label: 'Wavy 2A-2C' },
        { value: 'curly', label: 'Curly 3A-3C' },
        { value: 'coily', label: 'Coily 4A-4C' }
      ]
    },
    {
      id: 'type',
      question: 'Which option best describes your hair?',
      required: true,
      type: 'single',
      options: [
        { value: 'oily', label: 'Oily. I wash it every 1-2 days.' },
        { value: 'normal', label: 'Normal. I wash it every 3–4 days.' },
        { value: 'dry', label: 'Dry. I wash it every 5+ days.' },
        { value: 'dry_scalp_condition', label: 'I have a dry scalp condition.' }
      ]
    },
    {
      id: 'color',
      question: 'What color is your hair?',
      required: true,
      type: 'single',
      options: [
        { value: 'natural_blonde', label: 'Natural Blonde' },
        { value: 'bleachedblonde', label: 'Bleached Blonde' },
        { value: 'salon_colored', label: 'Salon-colored' },
        { value: 'brunette', label: 'Brunette' },
        { value: 'black', label: 'Black' },
        { value: 'red', label: 'Red' }
      ]
    },
    {
      id: 'scent',
      question: 'Which type of scent do you prefer?',
      required: true,
      type: 'single',
      options: [
        { value: 'fragrance_ok', label: 'All Scents' },
        { value: 'eo_only', label: 'Essential Oils Only' }
      ]
    }
    // {
    //   id: 'masc',
    //   question: 'Do you want us to include more masculine scents?',
    //   required: true,
    //   type: 'single',
    //   options: [
    //     { value: 'masc_ok', label: 'Yes' },
    //     { value: 'no_masc', label: 'No' }
    //   ]
    // }
  ]

  // ---- TEXT / COPY MAPS ----

  const textureWordMap = {
    straight: 'straight',
    wavy: 'wavy',
    curly: 'curly',
    coily: 'coily'
  }

  const colorWordMap = {
    natural_blonde: 'natural blonde',
    bleachedblonde: 'bleached blonde',
    salon_colored: 'salon-colored',
    brunette: 'brunette',
    black: 'black',
    red: 'red'
  }

  const scalpPhraseMap = {
    oily: 'an oily scalp',
    normal: 'a normal scalp',
    dry: 'a dry scalp',
    dry_scalp_condition: 'a sensitive scalp'
  }

  const titleByType = {
    oily: 'FOR OILY SCALPS',
    normal: 'FOR NORMAL SCALPS',
    dry: 'FOR DRY SCALPS',
    dry_scalp_condition: 'FOR SENSITIVE SCALPS'
  }

  const descriptionByType = {
    oily:
      'Discover a clarifying yet non-stripping routine crafted to keep your scalp feeling fresh while caring for your lengths.',
    normal:
      'Discover a balanced routine that maintains scalp harmony while keeping your hair healthy, shiny, and manageable.',
    dry:
      'Discover a deeply nourishing routine crafted to hydrate a dry scalp and restore softness, smoothness, and shine.',
    dry_scalp_condition:
      'Discover a gentle, fragrance-conscious routine crafted to calm and nourish sensitive scalps while keeping your hair looking and feeling its best.'
  }

  // ---- HERO IMAGES ----

  const heroImageMap = {
    straight_brunette: 'straight_brown.png',
    straight_natural_blonde: 'straight_blonde.png',
    straight_bleachedblonde: 'straight_bleachedblonde.png',
    straight_red: 'straight_red.png',
    straight_black: 'straight_black.png',
    straight_salon_colored: 'straight_colored.png',

    wavy_brunette: 'wavy_brown.png',
    wavy_natural_blonde: 'wavy_blonde.png',
    wavy_bleachedblonde: 'wavy_bleachedblonde.png',
    wavy_red: 'wavy_red.png',
    wavy_black: 'wavy_black.png',
    wavy_salon_colored: 'wavy_colored.png',

    curly_brunette: 'curly_brown.png',
    curly_natural_blonde: 'curly_blonde.png',
    curly_bleachedblonde: 'curly_bleachedblonde.png',
    curly_red: 'curly_red.png',
    curly_black: 'curly_black.png',
    curly_salon_colored: 'curly_colored.png',

    coily_brunette: 'coily_brown.png',
    coily_natural_blonde: 'coily_blonde.png',
    coily_bleachedblonde: 'coily_bleachedblonde.png',
    coily_red: 'coily_red.png',
    coily_black: 'coily_black.png',
    coily_salon_colored: 'coily_colored.png'
  }

  const DEFAULT_HERO_IMAGE = 'straight_brown.png'

  const buildFlavorCopy = ({ texture, type, color }) => {
    const tWord = textureWordMap[texture]
    const cWord = colorWordMap[color]
    const scalp = scalpPhraseMap[type]

    if (!tWord || !cWord || !scalp) return ''

    return `Your naturally ${tWord}, beautiful ${cWord} hair deserves the best. We understand you're on a quest to find the best products for ${scalp}.`
  }

  const buildProfileKey = answers => {
    const texture = answers.texture || 'unknown'
    const type = answers.type || 'unknown'
    const color = answers.color || 'unknown'
    return `${texture}_${type}_${color}`
  }

  const buildProfileData = answers => {
    const texture = answers.texture
    const type = answers.type
    const color = answers.color

    const profileKey = buildProfileKey(answers)
    const imgKey = `${texture}_${color}`
    const imageFile = heroImageMap[imgKey] || DEFAULT_HERO_IMAGE

    const flavor = buildFlavorCopy({ texture, type, color })
    const textureWord = textureWordMap[texture] || ''
    const colorWord = colorWordMap[color] || ''

    return {
      profileKey,
      hero: {
        image: `/cdn/shop/files/${imageFile}`,
        imageAlt: `${colorWord} ${textureWord} hair recommendation`.trim(),
        heading: 'For You!',
        tagline: 'WE HAVE THE PERFECT RECOMMENDATIONS FOR YOUR HAIR/SCALP TYPE!',
        flavor,
        footer: ''
      },
      title: titleByType[type] || '',
      description: descriptionByType[type] || ''
    }
  }

  // ---- QUIZ RESULT → COLLECTION HANDLE MAP ----

  const resultCollectionMap = {
    dry: {
      coily: {
        black: 'group-a',
        bleachedblonde: 'group-b',
        brunette: 'group-a',
        natural_blonde: 'group-b',
        red: 'group-a',
        salon_colored: 'group-b'
      },
      curly: {
        black: 'group-a',
        bleachedblonde: 'group-b',
        brunette: 'group-a',
        natural_blonde: 'group-b',
        red: 'group-a',
        salon_colored: 'group-b'
      },
      straight: {
        black: 'group-a',
        bleachedblonde: 'group-b',
        brunette: 'group-a',
        natural_blonde: 'group-b',
        red: 'group-a',
        salon_colored: 'group-b'
      },
      wavy: {
        black: 'group-a',
        bleachedblonde: 'group-b',
        brunette: 'group-a',
        natural_blonde: 'group-b',
        red: 'group-a',
        salon_colored: 'group-b'
      }
    },
    dry_scalp_condition: {
      coily: {
        black: 'group-f',
        bleachedblonde: 'group-f',
        brunette: 'group-f',
        natural_blonde: 'group-f',
        red: 'group-f',
        salon_colored: 'group-f'
      },
      curly: {
        black: 'group-f',
        bleachedblonde: 'group-f',
        brunette: 'group-f',
        natural_blonde: 'group-f',
        red: 'group-f',
        salon_colored: 'group-f'
      },
      straight: {
        black: 'group-f',
        bleachedblonde: 'group-f',
        brunette: 'group-f',
        natural_blonde: 'group-f',
        red: 'group-f',
        salon_colored: 'group-f'
      },
      wavy: {
        black: 'group-f',
        bleachedblonde: 'group-f',
        brunette: 'group-f',
        natural_blonde: 'group-f',
        red: 'group-f',
        salon_colored: 'group-f'
      }
    },
    oily: {
      coily: {
        black: 'group-c',
        bleachedblonde: 'group-h',
        brunette: 'group-c',
        natural_blonde: 'group-d',
        red: 'group-c',
        salon_colored: 'group-g'
      },
      curly: {
        black: 'group-c',
        bleachedblonde: 'group-h',
        brunette: 'group-c',
        natural_blonde: 'group-d',
        red: 'group-c',
        salon_colored: 'group-g'
      },
      straight: {
        black: 'group-c',
        bleachedblonde: 'group-h',
        brunette: 'group-c',
        natural_blonde: 'group-d',
        red: 'group-c',
        salon_colored: 'group-g'
      },
      wavy: {
        black: 'group-c',
        bleachedblonde: 'group-h',
        brunette: 'group-c',
        natural_blonde: 'group-d',
        red: 'group-c',
        salon_colored: 'group-g'
      }
    },
    normal: {
      coily: {
        black: 'group-i',
        bleachedblonde: 'group-i',
        brunette: 'group-i',
        natural_blonde: 'group-i',
        red: 'group-i',
        salon_colored: 'group-i'
      },
      curly: {
        black: 'group-i',
        bleachedblonde: 'group-i',
        brunette: 'group-i',
        natural_blonde: 'group-i',
        red: 'group-i',
        salon_colored: 'group-i'
      },
      straight: {
        black: 'group-i',
        bleachedblonde: 'group-i',
        brunette: 'group-i',
        natural_blonde: 'group-i',
        red: 'group-i',
        salon_colored: 'group-i'
      },
      wavy: {
        black: 'group-i',
        bleachedblonde: 'group-i',
        brunette: 'group-i',
        natural_blonde: 'group-i',
        red: 'group-i',
        salon_colored: 'group-i'
      }
    }
  }

  const getCollectionHandleForAnswers = answers => {
    const type = answers.type
    const texture = answers.texture
    const color = answers.color

    if (!type || !texture || !color) return null

    return (
      resultCollectionMap[type] &&
      resultCollectionMap[type][texture] &&
      resultCollectionMap[type][texture][color]
    ) || null
  }

  // ---- LOAD COLLECTION PRODUCTS INLINE + FILTER BY SCENT / MASC PREFERENCE ----

  const loadCollectionIntoResults = handle => {
    const container = resultsContainer.querySelector('[data-quiz-collection]')
    if (!container || !handle) return

    const isMobileViewport =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(max-width: 640px)').matches

    container.innerHTML = '<p>Loading your routine...</p>'

    fetch(`/collections/${handle}/products.json?limit=50`)
      .then(response => response.json())
      .then(data => {
        const products = data && data.products ? data.products : []

        if (!products.length) {
          container.innerHTML = '<p>No products found for this routine.</p>'
          return
        }

        const scentPref = state.answers.scent
        // const mascPref = state.answers.masc

        const filteredProducts = products.filter(product => {
          const rawTags = Array.isArray(product.tags)
            ? product.tags
            : typeof product.tags === 'string'
            ? product.tags.split(',')
            : []

          const lowerTags = rawTags.map(t => t.toLowerCase().trim())
          const hasEO = lowerTags.includes('essential oil bars')
          // const hasMens = lowerTags.includes("men's bars")

          if (scentPref === 'eo_only') {
            return hasEO
          }

          // if (scentPref === 'fragrance_ok' && mascPref === 'no_masc') {
          //   return !hasMens && !hasEO
          // }

          if (scentPref === 'fragrance_ok') return !hasEO

          return true
        })

        if (!filteredProducts.length) {
          container.innerHTML = '<p>No products found for this scent preference.</p>'
          return
        }

        const cardsHtml = filteredProducts
          .map(product => {
            const productUrl = `/products/${product.handle}`

            const images = Array.isArray(product.images) ? product.images : []
            const primaryImage = images[0]
            const secondaryImage = images[1]

            const variants = Array.isArray(product.variants) ? product.variants : []
            const firstAvailableVariant = variants.find(v => v.available) || variants[0]

            const sku =
              firstAvailableVariant && firstAvailableVariant.sku ? firstAvailableVariant.sku : ''

            const rawTags = Array.isArray(product.tags)
              ? product.tags
              : typeof product.tags === 'string'
              ? product.tags.split(',')
              : []

            const lowerTags = rawTags.map(t => t.toLowerCase().trim())

            const badges = []
            if (lowerTags.includes('new')) badges.push('NEW')
            if (lowerTags.includes('limited')) badges.push('LIMITED')
            if (firstAvailableVariant && !firstAvailableVariant.available) badges.push('SOLD OUT')

            const badgesHtml = badges.length
              ? `<div class="hair-quiz__product-badges">
          ${badges.map(label => `<span class="hair-quiz__badge">${label}</span>`).join('')}
        </div>`
              : ''

            const primaryImageHtml = primaryImage
              ? `<img
          class="hair-quiz__product-image hair-quiz__product-image--primary"
          src="${primaryImage.src}"
          alt="${product.title}"
          loading="lazy"
        >`
              : ''

            const secondaryImageHtml = secondaryImage
              ? `<img
          class="hair-quiz__product-image hair-quiz__product-image--secondary"
          src="${secondaryImage.src}"
          alt="${product.title}"
          loading="lazy"
        >`
              : ''

            return `
      <article class="hair-quiz__product-card">
        <a
          href="${productUrl}"
          class="hair-quiz__product-link"
          data-product-handle="${product.handle}"
          data-product-sku="${sku}"
        >
          <div class="hair-quiz__product-media">
            ${badgesHtml}
            ${primaryImageHtml}
            ${secondaryImageHtml}
          </div>
          <div class="hair-quiz__product-info" style="text-align:center">
            <h3 class="hair-quiz__product-title">${product.title}</h3>
          </div>
        </a>
      </article>
    `
          })
          .join('')

        container.innerHTML = `
          <div class="hair-quiz__products hair-quiz__products--grid">
            ${cardsHtml}
          </div>
        `
      })
      .catch(err => {
        console.error('Error loading collection products for handle:', handle, err)
        container.innerHTML = '<p>There was a problem loading your routine. Please try again.</p>'
      })
  }

  // ---- AJAX ADD TO CART HANDLER (kept in case you re-enable buttons) ----

  resultsContainer.addEventListener('click', event => {
    const button = event.target.closest('.js-quiz-add-to-cart')
    if (!button) return

    const variantId = button.dataset.variantId
    if (!variantId) return

    const originalText = button.textContent
    button.disabled = true
    button.textContent = 'Adding...'

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
      .then(response => {
        if (!response.ok) throw new Error('Cart error')
        return response.json()
      })
      .then(() => {
        button.textContent = 'Added!'
        setTimeout(() => {
          button.textContent = originalText
          button.disabled = false
        }, 1500)
      })
      .catch(err => {
        console.error('Add to cart failed', err)
        button.textContent = originalText
        button.disabled = false
      })
  })

  // ---- TRACK RECOMMENDATION CLICKS ----

  resultsContainer.addEventListener('click', event => {
    const link = event.target.closest('.hair-quiz__product-link')
    if (!link) return

    const sku = link.dataset.productSku || ''

    if (!sku) return

    sendQuizProgress({
      eventType: 'click_recommendation',
      productSku: sku
    })
  })

  // ---- STATE ----

  const state = {
    currentStepIndex: 0,
    answers: {}
  }

  // 3) RENDER STEPS
  const renderSteps = () => {
    stepsContainer.innerHTML = ''

    quizSteps.forEach((step, index) => {
      const stepEl = document.createElement('div')
      stepEl.className = 'quiz-step'
      if (index === state.currentStepIndex) stepEl.classList.add('is-active')
      stepEl.dataset.stepId = step.id

      stepEl.innerHTML = `
        <div class="hair-quiz__step-inner">
          <h2>${step.question}</h2>
          <div class="hair-quiz__options">
            ${step.options
              .map(option => {
                const selected = state.answers[step.id] === option.value
                return `
                  <button
                    type="button"
                    class="hair-quiz__option${selected ? ' is-selected' : ''}"
                    data-option-value="${option.value}"
                    data-step-id="${step.id}"
                  >
                    ${option.label}
                  </button>
                `
              })
              .join('')}
          </div>
        </div>
      `

      stepsContainer.appendChild(stepEl)
    })
  }

  const syncActiveStep = () => {
    const stepEls = stepsContainer.querySelectorAll('.quiz-step')
    stepEls.forEach((el, index) => {
      el.classList.toggle('is-active', index === state.currentStepIndex)
    })
  }

  // 4) EVENT HANDLERS — auto-advance on selection + progress tracking

  stepsContainer.addEventListener('click', event => {
    const button = event.target.closest('.hair-quiz__option')
    if (!button) return

    const stepId = button.dataset.stepId
    const value = button.dataset.optionValue
    if (!stepId || !value) return

    state.answers[stepId] = value

    // send step answer to backend
    sendQuizProgress({
      stepId,
      answer: value,
      eventType: 'step_answer'
    })

    const stepEl = button.closest('.quiz-step')
    if (!stepEl) return
    stepEl.querySelectorAll('.hair-quiz__option').forEach(btn => {
      btn.classList.toggle('is-selected', btn === button)
    })

    const currentIndex = state.currentStepIndex
    const currentStep = quizSteps[currentIndex]

    let isLastForUser =
      currentIndex === quizSteps.length - 1 ||
      (currentStep.id === 'color' && state.answers.type === 'dry_scalp_condition')

    // if (currentStep.id === 'scent') {
    //   const handle = getCollectionHandleForAnswers(state.answers)
    //
    //   const needsMascStep =
    //     value === 'fragrance_ok' &&
    //     handle &&
    //     ['group-a', 'group-b', 'group-c', 'group-d', 'group-i'].includes(handle)
    //
    //   if (value === 'eo_only' || !needsMascStep) {
    //     isLastForUser = true
    //   } else if (needsMascStep) {
    //     isLastForUser = false
    //   }
    // }

    if (currentStep.id === 'scent') isLastForUser = true

    if (isLastForUser) {
      showResults()
      return
    }

    state.currentStepIndex += 1
    syncActiveStep()
  })

  // 5) RESULTS

  const showResults = () => {
    const profile = buildProfileData(state.answers)
    const collectionHandle = getCollectionHandleForAnswers(state.answers)

    if (rootSection) {
      rootSection.classList.add('hair-quiz--showing-results')
    }

    stepsContainer.innerHTML = ''
    resultsContainer.hidden = false

    persistSessionIdToCart(sessionId)
    sendQuizProgress({ eventType: 'quiz_completed' })

    if (!profile) {
      resultsContainer.innerHTML = `
        <h2>Your routine is ready</h2>
        <p>We couldn’t match an exact profile yet, but here are some of our most-loved routines.</p>
      `
      return
    }

    const hero = profile.hero || null

    const heroHtml = hero
      ? `
        <div class="hair-quiz__result-hero" style="background-image:url('${hero.image}')">
          <div class="hair-quiz__result-hero-inner">
            <h2 class="hair-quiz__result-hero-heading">${hero.heading}</h2>
            <p class="hair-quiz__result-hero-tagline">${hero.tagline}</p>
            <p class="hair-quiz__result-hero-flavor">${hero.flavor}</p>
            <p class="hair-quiz__result-hero-dots">•••</p>
            <p class="hair-quiz__result-hero-footer">${hero.footer}</p>
          </div>
        </div>
      `
      : ''

    const titleHtml = profile.title ? `<h2>${profile.title}</h2>` : ''
    const descriptionHtml = profile.description ? `<p>${profile.description}</p>` : ''

    const collectionHtml = `
      <div class="hair-quiz__collection-wrap" data-quiz-collection>
        <!-- Collection products will load here -->
      </div>
    `

    resultsContainer.innerHTML = `
      ${heroHtml}
      ${titleHtml}
      ${descriptionHtml}
      ${collectionHtml}
    `

    if (collectionHandle) {
      loadCollectionIntoResults(collectionHandle)
    } else {
      console.warn('No collection handle found for answers:', state.answers)
    }
  }

  // INIT
  renderSteps()
  syncActiveStep()
})
